export default __webpack_public_path__ + "40ad513469aa2750a6bcdf72e9fdc46c.png";